import React, {useRef} from 'react';
import {useParams} from 'react-router-dom';
import Loader from '../../../Components/Loader/Loader';
import {asset, formatTimeUTC, translateToBanglaDigit} from "../../../helpers/helpers";
import useEmployeeById from "../../../Hooks/useEmployeeById";
import '../../../App.css'
import {FaPrint} from "react-icons/fa";
import {useReactToPrint} from "react-to-print";
import avatar from "../../../Assets/avatar.png"
import bdLogo from "../../../Assets/bdLogo.png";


const UpdatedEmployeeDataFullViewPage = () => {
    const {id} = useParams();
    const printRef = useRef();
    const {basicInfo: {data}, loading} = useEmployeeById(id);
    const handlePrint = () => {
        print();
    }
    const print = useReactToPrint({
        content: () => printRef.current,
    });

    const formatDateUTC = (date) => {
        if (!date) return '';
        const d = new Date(date);
        return `${d.getUTCDate().toString().padStart(2,'0')}-${(d.getUTCMonth()+1).toString().padStart(2,'0')}-${d.getUTCFullYear()}`;
    };

    if (loading) {
        return <Loader/>
    }

    return (
        <div className="component_container py-2 my-3">
            <div className="">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="float-end d-flex justify-content-between">
                            <button className="btn btn-primary" style={{marginRight: '10px'}} onClick={handlePrint}>
                                <FaPrint/>
                            </button>
                        </div>
                    </div>
                </div>
              
                <div className="row employee_info" ref={printRef}>
                    <div className="col-12">
                        <center>
                            <img className="mb-2" style={{width: 100 + "px"}} src={bdLogo} alt=""/>
                            <br/>
                            <strong>Personal Management Information System</strong>
                            <br/>
                            <strong>(PMIS)</strong>
                            <br/>
                        </center>
                    </div>
                    <div className="col-lg-12 mt-3">
                        <div className="card">
                            <h5 className="card-header card-header-colored">ব্যক্তিগত তথ্য</h5>
                            <div className="card-body">
                                <table width="100%">
                                    <tbody>
                                    <tr>
                                        <th style={{width: '9%'}} className="py-1">নাম (বাংলায়)</th>
                                        <th className="th-text-middle" style={{width: '1%'}}>:</th>
                                        <td style={{width: '30%'}}>{data?.name_in_bn}</td>
                                        <th style={{width: '9%'}}>নাম (ইংরেজিতে)</th>
                                        <th style={{width: '1%'}}>:</th>
                                        <td style={{width: '30%'}}>{data?.name_in_en}</td>
                                        <td style={{width: '20%', verticalAlign: 'top', textAlign: 'right' }} rowSpan={9}>
                                            <img style={{width: '180px', height: '180px'}} src={data?.image ? asset(data.image) : avatar} alt=""/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="py-1">জন্ম তারিখ</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{translateToBanglaDigit(data?.date_of_birth_view)}</td>
                                        <th>মাতার নাম (বাংলায়)</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.mother_name_in_bn}</td>
                                    </tr>
                                    <tr>
                                        <th className="py-1">মাতার নাম (ইংরেজিতে)</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.mother_name_in_en}</td>
                                        <th>পিতার নাম (বাংলায়)</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.father_name_in_bn}</td>
                                    </tr>
                                    <tr>
                                        <th className="py-1">পিতার নাম (ইংরেজিতে)</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.father_name_in_en}</td>
                                        <th>বৈবাহিক অবস্থা</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.marital_status_text}</td>
                                    </tr>
                                    <tr>
                                        <th className="py-1">ব্যাচ নম্বর</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.current_job_info?.batch_no}</td>
                                        <th>ক্যাডার</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.current_job_info?.cadre === 1 ? "ক্যাডার" :
                                            data?.current_job_info?.cadre === 2 ? "নন-ক্যাডার" :
                                                "অন্যান্য"}</td>
                                    </tr>
                                    <tr>
                                        <th className="py-1">রক্তের গ্রুপ</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.blood_group_text}</td>
                                        <th>শ্রেণি</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.current_job_info?.class}</td>
                                    </tr>
                                    <tr>
                                        <th className="py-1">জেন্ডার</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.gander_text}</td>
                                        <th>পাসপোর্ট নাম্বার</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.passport_no}</td>
                                    </tr>
                                    <tr>
                                        <th className="py-1">কর্মস্থল</th>
                                        <th className="th-text-middle">:</th>
                                        <td>{data?.current_job_info?.ministry_name}</td>
                                        <th className="py-1">সর্বশেষ হালনাগাদ</th>
                                        <th className="th-text-middle">:</th>
                                        <td>
                                            {translateToBanglaDigit(formatDateUTC(data?.latest_updated_at))}&nbsp;&nbsp;
                                            {translateToBanglaDigit(formatTimeUTC(data?.latest_updated_at))}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default UpdatedEmployeeDataFullViewPage;